/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @type ComparisonRuleValue
 *
 * @export
 */

export function ComparisonRuleValueFromJSON(json) {
  return ComparisonRuleValueFromJSONTyped(json, false);
}
export function ComparisonRuleValueFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  if (instanceOfboolean(json) || instanceOfnumber(json) || instanceOfstring(json)) {
    return json;
  }
  return false;
}
export function ComparisonRuleValueToJSON(value) {
  if (value == null) {
    return value;
  }
  if (instanceOfboolean(value) || instanceOfnumber(value) || instanceOfstring(value)) {
    return value;
  }
  return null;
}
function instanceOfboolean(value) {
  return typeof value === 'boolean';
}
function instanceOfnumber(value) {
  return typeof value === 'number';
}
function instanceOfstring(value) {
  return typeof value === 'string';
}